import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["type", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "loader-btn"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { key: 2 }

import router from '@/router';


interface Props {
    type: any
    styleBtn: String
    isDisabled?: boolean
    text?: any
    icon?: string | undefined
    iconName?: string | undefined
    iconClass?: string
    status?: boolean
    linkRouter?:any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'baseBtn',
  props: {
    type: null,
    styleBtn: null,
    isDisabled: { type: Boolean },
    text: null,
    icon: null,
    iconName: null,
    iconClass: null,
    status: { type: Boolean },
    linkRouter: null
  },
  setup(__props: any) {

const props = __props as {
    type: any
    styleBtn: String
    isDisabled?: boolean
    text?: any
    icon?: string | undefined
    iconName?: string | undefined
    iconClass?: string
    status?: boolean
    linkRouter?:any
};




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: __props.type,
    class: _normalizeClass(__props.styleBtn),
    disabled: __props.isDisabled
  }, [
    (__props.status)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("", true),
    (__props.icon && !__props.status)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: __props.icon,
          alt: __props.iconName,
          class: _normalizeClass(__props.iconClass)
        }, null, 10, _hoisted_3))
      : _createCommentVNode("", true),
    (__props.text && !__props.status)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.text), 1))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})